export default __webpack_public_path__ + "static/media/fileicon@2x.44055591.png";